import React from 'react'
import { PUBLIC_URL } from '../helpers'
import { DfinityLogo } from './DfinityLogo'

export function Header() {
  return (
    <header
      style={{
        background: `linear-gradient(90deg, #222e 0%, #222a 25%, #2224 100%),
        no-repeat url("${PUBLIC_URL}/hero.jpg") center/cover local`,
      }}
    >
      <div className="header-logo">
        <DfinityLogo width={256} />
      </div>
      <div className="header-text">
        <h1>The Entrepreneur's Journey</h1>
        The Internet Computer's superpowers at work
      </div>
    </header>
  )
}
